"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    CodeNotFound: 0,
    Success: 1,
    AnotherCodeAlreadySet: 2,
    CodeNotValidForCustomerType: 3
};


//////////////////
// WEBPACK FOOTER
// ./~/linksoft-albatros/src/CouponResponse.js
// module id = 463
// module chunks = 0